import { render, staticRenderFns } from "./FaqModule.vue?vue&type=template&id=4f1bdb9f"
import script from "./FaqModule.vue?vue&type=script&lang=js"
export * from "./FaqModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports